/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckA2Icon64Regular = forwardRef('CheckA2Icon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M50.518 17.56a1.5 1.5 0 0 0-2.121-2.12l-27.33 27.33a4.85 4.85 0 0 1-6.86 0L4.062 32.621a1.5 1.5 0 1 0-2.122 2.121l10.147 10.148a7.85 7.85 0 0 0 11.102 0l27.33-27.33Z" }),
        React.createElement("path", { d: "M63.518 17.56a1.5 1.5 0 0 0-2.121-2.12L32.3 44.534a1.5 1.5 0 1 0 2.121 2.122L63.518 17.56Z" })));
});
